<template>
  <van-popup
    v-model="show"
    position="right"
    closeable
    :style="{ width: '70%', height: '100%' }"
  >
    <div class="change-inner-box">
      <div class="choose-title">{{ title }}</div>
      <van-grid :gutter="10" :column-num="3" class="table-list">
        <van-grid-item
          v-for="item in tableList"
          :key="item.TableId"
          :text="item.TableName"
          class="table-item "
          :class="{ checked: selectKeys.includes(item.TableId) }"
          @click="chooseTable(item)"
        >
          <template slot="icon">
            <img class="table-img" src="@/assets/images/chair2.png" alt="" />
            {{ item.Seat }}
          </template>
        </van-grid-item>
      </van-grid>
      <van-button class="sure-btn" type="info" block @click="onSubmit"
        >确定</van-button
      >
    </div>
  </van-popup>
</template>

<script>
import "./restarant.less";
import restaurantManageApi from "@/api/restaurantManage.js";
import {
  Cell,
  CellGroup,
  Button,
  Card,
  Popup,
  Grid,
  GridItem,
  Icon,
  Notify,
} from "vant";
export default {
  name: "TableOperate",
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Card.name]: Card,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
  },
  props: {
    orderId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      show: false,
      selectKeys: "",
      tableList: [],
      title: "",
      currentTable: {},
    };
  },
  created() {},
  methods: {
    onShow(current) {
      this.show = true;
      this.currentTable = current;
      this.title = "当前桌台：" + current.TableName;
      this.getTableStatus();
    },
    getTableStatus() {
      restaurantManageApi
        .getTableStatus({ ShowForbiddens: false })
        .then(res => {
          // this.tableList = res.Data.TableStatusDetails;
          this.tableList = res.Data.TableStatusDetails.filter(
            el => el.Status == 1,
          );
          this.selectKeys = this.tableList[0].TableId;
        });
    },
    chooseTable(item) {
      this.selectKeys = this.selectKeys == item.TableId ? "" : item.TableId;
    },
    onSubmit() {
      if (!this.selectKeys) {
        Notify("请选择桌台");
        return false;
      }
      restaurantManageApi
        .changeTable({
          OrderId: this.orderId,
          SourceTableId: this.currentTable.TableId,
          TargetTableId: this.selectKeys,
        })
        .then(() => {
          this.show = false;
          this.$emit("update", this.selectKeys);
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.change-inner-box {
  height: 100vh;
  overflow-y: auto;
  .sure-btn {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .choose-title {
    padding: 10px;
    background: #fafafa;
  }
  .table-list {
    padding-bottom: 10px;
    padding-top: 5px;
    max-height: calc(100vh - 85px);
    overflow-y: auto;
    .table-item {
      margin-bottom: 5px;
      /deep/.van-grid-item__content--center {
        border: 1px solid transparent;
      }
      &.checked {
        /deep/.van-grid-item__content--center {
          border: 1px solid #f20;
          background: #fffafa;
        }
      }
    }
  }
}
</style>
